import { useState, useEffect, useRef } from 'react';
import {
  AppBar,
  Box,
  Typography,
  IconButton,
  Stack,
  Popper,
  Grow,
  ClickAwayListener,
  MenuList,
  MenuItem,
  Paper,
} from '@mui/material';
import { Auth } from 'aws-amplify';
import { useGetIdentity, useLogout } from 'react-admin';
import { useNavigate } from 'react-router-dom';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import SettingsIcon from '@mui/icons-material/Settings';
import LogoutIcon from '@mui/icons-material/Logout';
import logo from '../assets/images/logo.svg';
import { usersProvider } from '../providers';

const CustomAppBar = () => {
  const [username, setUsername] = useState('');
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);
  const navigate = useNavigate();
  const logout = useLogout();

  useEffect(() => {
    const getUserInfo = async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const userData = await usersProvider("GET", "/getUser", { username: user.getUsername() });
        setUsername(userData.UserAttributes.find(attr => attr.Name === "name")?.Value);
      } catch (error) {
        console.log("authenticated err", error);
      }
    };
    getUserInfo();
  }, []);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === 'Escape') {
      setOpen(false);
    }
  }

  const prevOpen = useRef(open);

  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }
    prevOpen.current = open;
  }, [open]);

  const goProfile = (event) => {
    navigate('/profile');
    handleClose(event);
  }

  return (
    <AppBar position="sticky" sx={{ width: { sm: '100%' }}}>
      <Stack direction="row" spacing={2}>
        <Box width='100%' display='flex' justifyContent='space-between' alignItems='center'>
          <Box
            component="img"
            src={logo}
            alt="Logo"
            sx={{
              width: 120,
              cursor: 'pointer',
              marginLeft: '15px',
            }}
            onClick={() => navigate('/#/overview', { replace: true })}
          />
          <Box display='flex' justifyContent='space-between' alignItems='center'>
            <Typography
              variant='subtitle2'
              margin='auto'
              marginRight='0px'
            >
              {username || ''}
            </Typography>
            <IconButton
              ref={anchorRef}
              id="composition-button"
              aria-controls={open ? 'composition-menu' : undefined}
              aria-expanded={open ? 'true' : undefined}
              aria-haspopup="true"
              onClick={handleToggle}
              sx={{ padding: "5px", margin: "15px" }}
            >
              <AccountCircleIcon />
            </IconButton>
          </Box>
          <Popper
            open={open}
            anchorEl={anchorRef.current}
            role={undefined}
            placement="bottom-start"
            transition
            disablePortal
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                style={{
                  transformOrigin:
                    placement === 'bottom-start' ? 'left top' : 'left bottom',
                }}
              >
                <Paper>
                  <ClickAwayListener onClickAway={handleClose}>
                    <MenuList
                      autoFocusItem={open}
                      id="composition-menu"
                      aria-labelledby="composition-button"
                      onKeyDown={handleListKeyDown}
                    >
                      <MenuItem onClick={goProfile}>
                        <SettingsIcon sx={{marginRight: "10px"}} />
                        Profile
                      </MenuItem>
                      <MenuItem onClick={logout}>
                        <LogoutIcon sx={{marginRight: "10px"}}/>
                        Logout
                      </MenuItem>
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </Box>
      </Stack>
    </AppBar>
  );
};

export default CustomAppBar;
